import { defineStore } from 'pinia';

export const useContentPages = defineStore('page-content', {
    state: () => ({
        statusRegionSelect: false,
        supportShow: false,
        contactFormShow: false,
        showSuccessModal: false,
        showErrorModal: false,
        successMessage: '',
        consultationTranslate: { textButton: '', phone: '', phoneText: '' },
        consultForm: {},
        langLoading: false,
    }),
    getters: {
        getDefaultCountry: state => {
            return state.countryList?.find(item => item.id === 1);
        },
        getContactFormData: state => {
            return state.consultForm;
        },
    },
    actions: {
        setSuccessMessage(message) {
            this.successMessage = message;
        },
        updateSuccessModal(payload) {
            this.showSuccessModal = payload;
        },
        updateErrorModal(payload) {
            this.showErrorModal = payload;
        },
        setConsultationTranslate(title, phone, phoneText) {
            this.consultationTranslate.textButton = title;
            this.consultationTranslate.phone = phone;
            this.consultationTranslate.phoneText = phoneText;
        },
        setContentConsultForm(formParams) {
            this.consultForm = { ...formParams };
        },
        setLangLoading(payload) {
            this.langLoading = payload;
        },
        updateStatusRegionSelect(payload) {
            this.statusRegionSelect = payload;
        },
        updateStatusSupport(payload) {
            this.supportShow = payload;
        },
        updateStatusContactForm(payload) {
            this.contactFormShow = payload;
        },
    },
    persist: {
        paths: [
            'statusRegionSelect',
            'consultationTranslate',
            'consultForm'
        ],
    },
});
